import type {
  ContentObjectView,
  WithingsOrderPostContentObjectDetail,
  WithingsOrderPostContentObjectList,
} from 'models';
import { useState } from 'react';
import { routes } from 'routes/routes';
import { Button, ReadMore, RichTextRenderer, Row, Text, Title } from 'ui';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- Break circular dependency
import { Subscribe } from 'features/programs/subscribe';
import { Translation } from 'features/translations';
import { useReloadContentObjectMutation } from '../../../queries';

type P = {
  item: WithingsOrderPostContentObjectDetail | WithingsOrderPostContentObjectList;
  showReadMore?: boolean;
  view: ContentObjectView;
};

const WithingsOrderPostContentObjectBody = ({ item, showReadMore, view }: P) => {
  const {
    filledWithingsOrder: isFilledWithingsOrder,
    id,
    program,
    type,
    withings_order_post: withingsOrderPost,
  } = item;
  const [isSubscribeOpened, setIsSubscribeOpened] = useState(false);
  const { mutateAsync: reloadWithingsOrderPost } = useReloadContentObjectMutation();

  const body = (
    <>
      {withingsOrderPost.htmlContent ? (
        <RichTextRenderer data={withingsOrderPost.htmlContent} />
      ) : (
        <div>{withingsOrderPost.textContent}</div>
      )}
      {withingsOrderPost.textContent ? <Translation id={withingsOrderPost.id} type={type} /> : null}
    </>
  );

  return (
    <>
      {withingsOrderPost.title ? <Title level={5}>{withingsOrderPost.title}</Title> : null}
      {showReadMore ? <ReadMore>{body}</ReadMore> : body}

      {isFilledWithingsOrder ? (
        <Text>Order was successful!</Text>
      ) : (
        <Row align="middle" justify="center">
          {view === 'bookmark' ? (
            <Button navigate={{ to: routes.contentObjects.withingsOrderPosts(id) }} size="large" type="primary">
              Create order
            </Button>
          ) : (
            <Button
              onClick={() => {
                setIsSubscribeOpened(true);
              }}
              size="large"
              type="primary"
            >
              Create order
            </Button>
          )}
        </Row>
      )}

      <Subscribe
        isOpened={isSubscribeOpened}
        onCancel={async () => {
          setIsSubscribeOpened(false);
          await reloadWithingsOrderPost({ filter: { id } });
        }}
        onSuccess={async () => {
          setIsSubscribeOpened(false);
          await reloadWithingsOrderPost({ filter: { id } });
        }}
        programId={program.id}
      />
    </>
  );
};

export default WithingsOrderPostContentObjectBody;
